import { DocLayout } from './DocLayout';

export default function DocParticipanti() {
  return (
    <DocLayout title="Participanți">
      <h2>Prezentare generală</h2>
      <p>
        Lista de participanți afișează toți utilizatorii care s-au înregistrat la o activitate prin sistemul intern de înregistrare.
        Accesezi lista din butonul <strong>Participanți</strong> (iconul de persoane) din tabelul de activități.
      </p>

      <h2>Informații afișate</h2>
      <p>Pentru fiecare participant vezi:</p>
      <ul>
        <li><strong>Nume complet</strong> — prenume și nume.</li>
        <li><strong>Email</strong> — adresa de email a contului.</li>
        <li><strong>Telefon</strong> — dacă a fost completat la înregistrare.</li>
        <li><strong>Vârstă</strong> — calculată din data nașterii, dacă a fost furnizată.</li>
        <li><strong>Status</strong> — Confirmat sau Anulat.</li>
        <li><strong>Data înregistrării</strong> — momentul înscrierii.</li>
      </ul>

      <h2>Statistici</h2>
      <p>În partea de sus a paginii vezi:</p>
      <ul>
        <li><strong>Total</strong> — numărul total de înregistrări (inclusiv anulate).</li>
        <li><strong>Confirmați</strong> — participanți cu status activ.</li>
        <li><strong>Anulați</strong> — participanți care au fost anulați (de ei sau de staff).</li>
        <li><strong>Locuri</strong> — dacă activitatea are limită, afișează ocuparea (ex: 15/50).</li>
      </ul>

      <h2>Acțiuni</h2>
      <ul>
        <li><strong>Anulează înregistrarea</strong> — anulează participarea unui utilizator (cu confirmare). Înregistrarea rămâne vizibilă cu status Anulat.</li>
        <li><strong>Printează</strong> — deschide o versiune de printare a listei într-o fereastră nouă.</li>
        <li><strong>Export CSV</strong> — descarcă un fișier CSV cu toți participanții.</li>
      </ul>

      <h2>Filtrare</h2>
      <p>Poți filtra lista după:</p>
      <ul>
        <li><strong>Căutare</strong> — după nume sau email.</li>
        <li><strong>Status</strong> — Confirmat sau Anulat.</li>
      </ul>
      <p>Filtrele se aplică și la printare și export CSV.</p>

      <h2>Excludere voluntari</h2>
      <p>
        Un utilizator nu poate fi simultan participant și voluntar (în așteptare sau aprobat) la aceeași activitate.
        Dacă un voluntar este respins sau se retrage, poate apoi să se înregistreze ca participant.
        Consultă <a href="/staff/documentatie/voluntari">documentația voluntarilor</a> pentru detalii.
      </p>

      <h2>Vizibilitate pentru prieteni</h2>
      <p>
        Prietenii organizatori pot vedea lista de participanți pentru activitățile lor,
        dar cu restricții dacă nu au completat procesul de validare (DPA).
        Consultă <a href="/staff/documentatie/dpa">documentația DPA</a> pentru detalii.
      </p>
    </DocLayout>
  );
}
